import Guid from '@/app/utils/guid'
import moment from 'moment'
import { ProjectStatus } from '@/projects/entities/project-status'
import Entity from '@/common/models/entity'

export default class Project extends Entity {

  public name = ''
  public description = ''
  public status = ProjectStatus.Draft
  public topicGroups = []
  public actionGroups = []
  public projectStakeholderGroups = []
  public tenantId = ''
  public tenant = null
  public changedOn: moment.Moment = moment()
  public image: File = new File([], '')
  public roundedCorners: boolean = false
  public stakeholderDiagramQuadrantLabelTL: string = ''
  public stakeholderDiagramQuadrantLabelTR: string = ''
  public stakeholderDiagramQuadrantLabelBL: string = ''
  public stakeholderDiagramQuadrantLabelBR: string = ''
}
